export default __webpack_public_path__ + "static/titilliumweb-semibold-webfont-1a64ed80d44735e30c660aadf5270d28.eot";